import { useEffect, useMemo } from 'react';

import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import Dashboard from '@uppy/dashboard';

import '@uppy/core/css/style.min.css';
import '@uppy/dashboard/css/style.min.css';
import '@uppy/webcam/css/style.min.css';

import { AttachmentsArea } from '../widgets';
import { rest } from '../services';
import { FILE_UPLOADED_EVENT } from '../events/Gui';
import '../css/file.css';

export const FileInput = (props) => {
  const uppy = useMemo(() => {
    const u = new Uppy();

    u.use(XHRUpload, { endpoint: props.uploadUrl });
    u.use(ThumbnailGenerator, { thumbnailWidth: 100 });

    u.on('file-added', () => {
      u.getPlugin('XHRUpload').setOptions({
        headers: {
          Authorization: `Bearer ${rest.getBearerToken()}`
        }
      });
    });

    u.on('thumbnail:generated', async (file, preview) => {
      const blob = await fetchBlob(preview);
      u.setFileMeta(file.id, { preview: blob });
      u.upload();
    });

    u.on('upload-success', (file, response) => {
      FILE_UPLOADED_EVENT.publish({ id: response.body.id, name: file.name });
    });

    return u;
    // props.uploadUrl intentionally not included here; we update endpoint in an effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Keep endpoint in sync if props.uploadUrl changes
  useEffect(() => {
    const plugin = uppy.getPlugin('XHRUpload');
    if (plugin) plugin.setOptions({ endpoint: props.uploadUrl });
  }, [uppy, props.uploadUrl]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      uppy.cancelAll();
      uppy.close();
    };
  }, [uppy]);

  useEffect(() => {
    const dashboard = uppy.getPlugin('Dashboard');
    if (!dashboard) {
      uppy.use(Dashboard, {
        inline: true,
        target: '#uppy-dashboard',
        restrictions: { maxNumberOfFiles: 1 },
        showSelectedFiles: false,
        proudlyDisplayPoweredByUppy: false
      });
    } else {
      dashboard.setOptions({
        inline: true,
        target: '#uppy-dashboard',
        restrictions: { maxNumberOfFiles: 1 },
        showSelectedFiles: false,
        proudlyDisplayPoweredByUppy: false
      });
    }
  }, [uppy]);

  return (
    <>
      <AttachmentsArea {...props} />
      {!props.readOnly ? <div id="uppy-dashboard" /> : null}
    </>
  );
};

async function fetchBlob(blobUrl) {
  const res = await fetch(blobUrl);
  return await res.blob();
}
